import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss']
})
export class TextComponent implements OnInit {

  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() label: string;
  @Input() hint: string;
  @Input() min: number;
  @Input() minLength: number;
  @Input() maxLength: number;
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() max: number;
  @Input() type: 'text' | 'email' | 'password' | 'tel' | 'number' | 'textarea'|'rang';
  @Input() class: string = 'flex-auto  ml-2 mr-2 '
  @Output('press') press = new EventEmitter<string>();
  constructor() { }

  ngOnInit(): void {


  }

}
